document.addEventListener('variant:add', function(event) {
  let productAddedId = event.detail.items[0].product_id;
  let productInfoBlockList = event.target.closest('.product-info__block-list');
  let productForm = event.target.closest('product-form');
  let productFreeSampleVariant = '';
  let productInfoGiftWrap = '';
  let productInfoGiftWrapVariant = '';
  let productInfoQty = '';

  if(productForm) {
    productFreeSampleVariant = productForm.querySelector('#free-sample');
  }
  
  if(productInfoBlockList) {
    productInfoGiftWrap = productInfoBlockList.querySelector('[data-block-type="gift-wrap"] [name*="properties"]');
    productInfoGiftWrapVariant = productInfoBlockList.querySelector('[data-block-type="gift-wrap"] #gift-wrap-variant');
    productInfoQty = productInfoBlockList.querySelector('[data-block-type="buy-buttons"] quantity-input input');
  }

  if(productInfoGiftWrap && productInfoGiftWrap.checked) {
    const formData = {
    'items': [
      {
        'id': productInfoGiftWrapVariant.value,
        'parent_line_key': event.detail.items[0].key,
        'quantity': productInfoQty.value
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
      setTimeout(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 600); 
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  if(productFreeSampleVariant) {
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(cart => {
      const cartItems = cart.items;
      let addSample = true;

      // Example: loop through each item
      cartItems.forEach(item => {
        console.log(item)
        if((item.properties['_free_sample_parent'] == productAddedId) || item.id == productFreeSampleVariant.value) {
          addSample = false;
          return;
        }
      });

      if(addSample) {
        const formData = {
        'items': [
          {
            'id': productFreeSampleVariant.value,
            'quantity': 1,
            'properties': {
              '_free_sample_parent': productFreeSampleVariant.dataset.freeSampleParent,
              '_free_sample': 'true'
            }
          }]
        };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          }, 600);
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
  
  }
});

document.addEventListener('cart:change', function(event) {
  let cartItems = event.detail.cart.items;
  if (event.detail.baseEvent == 'line-item:change') {
    let addedItem = event.detail.cart.items_added[0];
    let removedItem = event.detail.cart.items_removed[0];

    if (addedItem) {
      cartItems.forEach((item, index) => {
        let itemParentRelationship = item.parent_relationship;
        if (itemParentRelationship && itemParentRelationship.parent_key == addedItem.view_key) {
          const formData = {
            'id': item.key,
            'quantity': item.quantity + addedItem.quantity
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
            .then(response => {
              return response.json();
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200); 
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      });
    } else if (removedItem) {
      cartItems.forEach((item, index) => {
        let itemParentRelationship = item.parent_relationship;
        if (itemParentRelationship && itemParentRelationship.parent_key == removedItem.view_key) {
          const formData = {
            'id': item.key,
            'quantity': item.quantity - removedItem.quantity
          };

          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
            .then(response => {
              return response.json();
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              }, 200); 
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      });
    }

    const removedItems = event.detail.cart.items_removed;
    if (!removedItems || removedItems.length === 0) return;

    // Reconstruct the full previous cart to determine what was fully removed vs qty-reduced
    const previousItems = [...cartItems, ...removedItems];

    removedItems.forEach(function(removedItem) {
      const stillInCart = cartItems.some(item => item.variant_id === removedItem.variant_id);

      // If a variant with the same ID is still in the cart, it was a qty reduction not a full removal
      // (Checking variant_id since the same product could have multiple variants)
      if (stillInCart) return;

      // This item was fully removed — check if it's the parent of any free sample
      const removedProductId = removedItem.product_id;

      // Find a free sample whose parent is this product
      const freeSample = cartItems.find(item =>
        item.properties && item.properties['_free_sample_parent'] == removedProductId
      );

      if (!freeSample) return;

      // Check whether any other (non-sample) items in the cart share the same parent product
      const parentStillRepresented = cartItems.some(item =>
        item.product_id === removedProductId &&
        !(item.properties && item.properties['_free_sample_parent'])
      );

      if (parentStillRepresented) return;

      // No qualifying products remain — remove the free sample
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: freeSample.key, quantity: 0 })
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    });
  }

  setTimeout(() => {
    let keys = JSON.parse(document.getElementById('free-sample-keys').textContent || '[]');
    if (keys.length === 0) return;

    (async function() {
      for (const key of keys) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })();
  }, 600); 
});


document.addEventListener('change', function(event) {
    
    // 1. Check if the changed element is a checkbox
    const isCheckbox = event.target.type === 'checkbox';
    
    // 2. Check if that checkbox lives inside your target container
    const isInsideFreeSamples = event.target.closest('.cart-drawer__free-samples');
    
    // 3. Only run the code if both conditions are met
    if (isCheckbox && isInsideFreeSamples) {
        if (event.target.checked) {
            let cartDrawerFreeSampleVariant = event.target.value;
            const formData = {
            'items': [
              {
                'id': cartDrawerFreeSampleVariant,
                'quantity': 1,
                'properties': {
                  '_free_sample': 'true'
                }
              }]
            };
            
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }, 600);
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        } else {
            let cartDrawerFreeSampleVariant = event.target.value;
            const formData = {
              'id': cartDrawerFreeSampleVariant,
              'quantity': 0
            };
            
            fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              setTimeout(() => {
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }, 600);
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
    }
});

document.addEventListener('cart:change', async function(event) {
  const cartItems = event.detail.cart.items;

  // Find all free samples added by our system
  const ourFreeSamples = cartItems.filter(item =>
    item.properties && item.properties['_free_sample'] != null
  );
  console.log(cartItems);

  if (ourFreeSamples.length === 0) return;

  // For each of our free samples, find a duplicate added by another system
  const duplicateKeys = [];

  ourFreeSamples.forEach(function(ourSample) {
    const appSampleAlsoPresent = cartItems.some(item =>
      item.variant_id === ourSample.variant_id &&
      item.key !== ourSample.key &&
      !(item.properties && item.properties['_free_sample'] != null)
    );
    if (appSampleAlsoPresent) duplicateKeys.push(ourSample.key);
  });

  if (duplicateKeys.length === 0) return;

  for (const key of duplicateKeys) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
});

document.addEventListener('click', async function(event) {
  const checkoutButton = event.target.closest('[name="checkout"], [href="/checkout"], #checkout');
  if (!checkoutButton) return;

  const duplicateKeys = JSON.parse(document.getElementById('duplicate-sample-keys')?.textContent || '[]');
  if (duplicateKeys.length === 0) return;

  event.preventDefault();

  for (const key of duplicateKeys) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  window.location.href = '/checkout';
}, true); // capture phase so we run before other click handlers